import React, { memo as Memo, useMemo, useEffect, useRef } from 'react'
import { useRouter } from 'next/router'

//* HOC's
import { withDataContext, withUIContext } from 'context'

//* Components
import { Page } from 'components/common'
import { SingleNews } from 'components/pages'

//* Style
import NewsContainerStyle from 'styles/pages/NewsContainerStyle'

const News = Memo(({ news, pageParams, prevPageParams, winHeight, selectedLang, loading, winWidth, ...props }) => {
    const newsContRef = useRef()
    const router = useRouter()

    const pageData = useMemo(
        () => news?.[loading ? prevPageParams?.queryName : pageParams?.queryName]?.[selectedLang],
        [news, pageParams?.queryName, prevPageParams, loading, selectedLang]
    )

    useEffect(() => {
        window.addEventListener('scroll', scroll)
        return () => {
            window.removeEventListener('scroll', scroll)
        }
    }, [router.query, loading])

    const scroll = () => {
        if ((newsContRef?.current?.getBoundingClientRect().y + newsContRef?.current?.clientHeight < winHeight * 0.85) && !pageParams.selectedSlug && !loading) {
            const currentPage = Number(router.query.page || 1)
            const isLastPage = currentPage * pageData?.pageSize >= pageData?.total

            if (!isLastPage && !loading) {
                router.push(`/news/?page=${currentPage + 1}`, undefined, { scroll: false })
            }
        }
    }

    const storeNews = useMemo(() => {
        let arr = [1, 2, 3]

        const itemsRowCount = winWidth < 768 ? 1 : winWidth < 1280 ? 2 : 3
        const count = pageData?.news?.length
        const isLast = count % itemsRowCount

        return pageData?.news.map((i, k) => {
            if (arr.length === 0) {
                arr = [1, 2, 3]
            }

            let ind = Math.floor(Math.random() * arr.length)
            const typeInd = arr[ind]

            arr = arr.filter((j) => {
                return j != arr[ind]
            })

            const isLastItem = ((isLast && count - k <= isLast) || (!isLast && count - k <= itemsRowCount)) && count >= 3 * itemsRowCount ? 'lastRowItem' : ''

            return <SingleNews url={i.slug} key={k} className={`type-${typeInd} ${isLastItem}`} image={i.featured_image} title={i.title} date={i.date} />
        })

    }, [pageData, winWidth])

    return (
        <Page>
            <NewsContainerStyle className="FlexBoxContainer" ref={newsContRef}>
                {storeNews}
            </NewsContainerStyle>
        </Page>
    )
})

export default withUIContext(withDataContext(News, ['news', 'loading']), ['winWidth', 'winHeight'])

export const getServerSideProps = async ({ query }) => { return { props: {} } }

